export default "__VITE_ASSET__c23NgAS4__"